module.exports = __webpack_public_path__ + "static/media/sf-test-3.f5223168.mp3";